import type { ReactElement } from 'react';
import { useMemo } from 'react';

import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import MenuIcon from '@mui/icons-material/Menu';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, IconButton, Typography } from '@mui/material';

import { useLocation } from 'react-router-dom';

import { useModal } from 'hooks/useModal';
import Menu from 'components/Drawer/Menu';

import { routesNames } from 'routes/Route';

import Profile from 'components/Drawer/Profile';

import styles from './styles';

const BaseHeader = (): ReactElement => {
  const location = useLocation();
  const { isOpen, handleOpen, handleClose } = useModal();
  const {
    isOpen: isOpenProfile,
    handleOpen: handleOpenProfile,
    handleClose: handleCloseProfile,
  } = useModal();
  const routeName = useMemo(
    () => routesNames.find(value => value.path === location.pathname),
    [location.pathname],
  );

  return (
    <AppBar sx={styles.headerContainer} enableColorOnDark position="sticky">
      <Toolbar variant="dense" sx={styles.toolbar}>
        <Box sx={styles.menuTitleRow}>
          <IconButton
            edge="start"
            color="inherit"
            onClick={handleOpen}
            aria-label="Abrir menu de navegação"
            size="medium"
          >
            <MenuIcon sx={styles.icon} aria-hidden />
          </IconButton>
          <Typography
            variant="subtitle1"
            component="span"
            sx={styles.routeTitle}
          >
            {routeName?.name ?? ''}
          </Typography>
          <Menu isOpen={isOpen} anchor="left" onClose={handleClose} />
        </Box>
        <IconButton
          edge="end"
          color="inherit"
          onClick={handleOpenProfile}
          aria-label="Abrir perfil"
          size="medium"
        >
          <AccountCircleIcon sx={styles.icon} aria-hidden />
        </IconButton>
        <Profile
          isOpen={isOpenProfile}
          anchor="right"
          onClose={handleCloseProfile}
        />
      </Toolbar>
    </AppBar>
  );
};

export default BaseHeader;
